import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import type { BadgeProps } from '@mui/material/Badge';
import Badge from '@mui/material/Badge';

import {
  blueBlack400,
  blueBlack630,
  blueBlack700,
  green400,
  greyLight700,
  white,
} from '../../../../../theme/videa-style-tokens';

export const ImageBrowserButton = styled.div<{
  count?: number;
}>`
  margin: 0 1em 0 auto;

  .filter-button {
    color: ${greyLight700};
    font-size: 0.875em;
    height: 2.5em;
    ${({ count }) =>
      count
        ? css`
            color: white;
            background-color: ${green400};
          `
        : css`
            background-color: ${blueBlack700};
          `}
    padding: 0.15em 1.875em 0.15em 0.75em;
    border: none;
    border-radius: 0.375em;
    text-align: left;
  }
  svg {
    fill: ${white};
    margin-right: 6px;
  }
  .MuiSvgIcon-root {
    height: 1.5em;
    width: 1.5em;
  }

  &.MuiIconButton-root {
    font-size: 1em;
    font-weight: 400;
  }
`;

export const ImageBrowserDrawer = styled.div`
  font-size: 22.5px;
  .expanded-drawer {
    .MuiPaper-root {
      background-color: rgba(16, 16, 16, 1);
      position: absolute;
      height: calc(100% - 6em);
    }
  }
  .drawer {
    .MuiPaper-root {
      background-color: rgba(16, 16, 16, 1);
      position: absolute;
      overflow: hidden;
      max-height: 5.5em;
    }
  }
  .drawer-container {
    background-color: rgba(16, 16, 16, 1);
    padding: 0 1em 0 0;
    .image-layout {
      display: flex;
      flex-direction: row;
      padding: 0 0 0 0.5em;
      align-items: center;
      justify-content: center;
      height: 5.5em;
      .image-bucket {
        display: flex;
        flex-direction: row;
        margin: 0 0 0 3em;
        max-width: 1330px;
        width: calc(100% - 3em);
        justify-content: center;
        align-items: center;
      }
    }
  }
  .expanded-drawer-container {
    padding: 0.5em 1em 2em 1em;
    background-color: rgba(16, 16, 16, 1);
    color: white;
    height: calc(100% - 3em);
    .image-layout {
      display: flex;
      flex-direction: row;
      gap: 0.25em;
      height: 100%;
      .image-bucket {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin: 0 0 0 3em;
        width: calc(100% - 3em);
        height: 100%;
        justify-content: center;
        align-items: center;
      }
    }
    .toggle-height {
      margin: 1em 0 0 0;
    }
  }
  .icon {
    color: white;
    width: 1.5em;
    .icon-shape {
      fill: white;
    }
  }
  .close-button {
    background-color: transparent;
    position: absolute;
    z-index: 100;
    right: 0.15em;
    width: 2em;
    height: 1.5em;
    min-height: 1.5em;
    min-width: 1em;
    .icon {
      width: 0.85em;
    }
    &:hover {
      opacity: 0.5;
      background-color: black;
    }
  }
  .arrow {
    background-color: transparent;
    min-width: 0.5em;
    width: 2em;
    .icon {
      width: 1em;
      height: 1em;
      color: white;
      margin-left: 0.5em;
    }
    &:hover {
      opacity: 0.5;
      background-color: black;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
  .pages {
    position: absolute;
    bottom: 0em;
    left: 0;
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .button {
      padding: 0.25em;
    }
    .icon {
      height: 0.5em;
    }
  }
`;

export const ToggleGroup = styled(ToggleButtonGroup)`
  position: absolute;
  left: 0.5em;
  color: ${white};
  column-gap: 0.125em;
  margin: 0.125em 0.125em 0.5em 0.125em;
  margin-right: 0.5em;
  gap: 0.15em;
  min-height: 4em;
`;

export const ToggleButtonStyled = styled(ToggleButton)`
  border: 0;
  border-radius: 0.375em;
  padding: 0;
  height: 1.4em;
  width: 2em;
  opacity: 50%;
  &.Mui-selected {
    background-color: ${blueBlack400};
    border-radius: 0.375em;
    opacity: 100%;
  }
  &.Mui-selected:hover,
  &:hover {
    background-color: ${blueBlack630};
  }
`;

export const IconWrapper = styled.div`
  padding: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VideaBadge = styled(Badge)<BadgeProps>(() => ({
  '& .MuiBadge-badge': {
    right: '-1em',
    top: 0,
    padding: '0 .025em',
  },
}));
